<script setup lang="ts">
    import { inject, computed } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { FeatureService } from '@shared/directives/Feature.service';

    const props = defineProps<{
        feature: string;
        hideWhenLocked?: boolean;
    }>();

    const injectorAccess = inject(injectorAccessInjectionKey);
    const featureService = injectorAccess?.injector.get(FeatureService);
    const isLocked = computed(() => featureService ? !featureService.hasFeature(props.feature) : false);
</script>

<template>
    <template v-if="!isLocked">
        <slot />
    </template>
    <template v-else-if="!hideWhenLocked">
        <slot name="locked" />
    </template>
</template>
